const clearLocationState = () => {
  // clear react router dom's location state without rerenders
  window.history.replaceState({}, document.title);
}

export { clearLocationState }